import { useEffect, useState } from 'react';

const API = '/api';

// ─── useBookmarkReminders ─────────────────────────────────────────
// Loads all active reminders for the current user once, indexes them
// by bookmark_id, and returns the map. The bookmark grid uses this
// to show a ReminderBadge on any card that has an upcoming reminder.
//
// Intentionally load-once — reminders don't change often enough to
// justify polling here, and the ReminderAlerts hook already handles
// due-date pings via useReminderPolling.
export function useBookmarkReminders(user) {
    const [reminders, setReminders] = useState({});
    useEffect(() => {
        if (!user) return;
        fetch(`${API}/reminders`, { credentials: 'include' })
            .then((r) => (r.ok ? r.json() : []))
            .then((items) => {
                const map = {};
                items.forEach((r) => { map[r.bookmark_id] = r; });
                setReminders(map);
            })
            .catch((err) => console.error('Failed to fetch reminders:', err));
    }, [user]);
    return reminders;
}
